import Dispatcher from "flux/lib/Dispatcher"
export const AppDispatcher = new Dispatcher()
